/**
 * ConnectionStatus Component
 *
 * Minimal pill showing connection status for multiplayer deployment.
 */

import React from 'react';
import styles from './ConnectionStatus.module.css';

export interface ConnectionStatusProps {
  /** Whether this client is connected to Socket.IO */
  isConnected: boolean;
  /** Whether the opponent is connected */
  opponentConnected: boolean;
  /** The opponent's player ID */
  opponentPlayerId: 'player1' | 'player2' | null;
  /** Error message if any */
  error?: string | null;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  isConnected,
  opponentConnected,
  error
}) => {
  const getStatusClass = () => {
    if (error) return styles.error;
    if (!isConnected) return styles.connecting;
    if (!opponentConnected) return styles.waiting;
    return styles.connected;
  };

  const getStatusText = () => {
    if (error) return 'Error';
    if (!isConnected) return 'Connecting...';
    if (!opponentConnected) return 'Waiting for opponent';
    return 'Both connected';
  };

  return (
    <div className={`${styles.pill} ${getStatusClass()}`}>
      <div className={styles.dot} />
      <span className={styles.text}>{getStatusText()}</span>
    </div>
  );
};

export default ConnectionStatus;
